import { useFetch } from '@/shared/hooks/useFetch';
import { queryKeys } from '@/shared/api/queryKeys';
import {
  apiWarehouseProductGet,
  apiWarehouseProductsListGet,
} from '@/entities/warehouse/modules/api/warehouse';
import type { ApiWarehouseProductsListParams } from '@/shared/types/api/warehouse';

export const useWarehouseProductsList = (params: ApiWarehouseProductsListParams) =>
  useFetch({
    api: () => apiWarehouseProductsListGet(params),
    keywords: queryKeys.warehouseProducts.list(params),
    staleTime: 60_000,
  });

export const useWarehouseProductDetail = (id: string | undefined) =>
  useFetch({
    api: () => apiWarehouseProductGet(id ?? ''),
    keywords: queryKeys.warehouseProducts.detail(id ?? ''),
    enabled: Boolean(id),
    staleTime: 30_000,
  });
